export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.options.scrollBehavior = () => {
    return false;
  };
});
// This plugin modifies the router's scroll behavior to disable automatic scrolling.
// It prevents the router from scrolling to the top of the page when navigating between routes.